import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import LogRocket from "logrocket";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "utils/analytics"; // note: this will initialize it
import { preventReload } from "utils/windowRelocation";
import * as mouseflow from "utils/mouseflow";
import * as ABTesting from "utils/ABTesting";

if (process.env.NODE_ENV === "production") {
  preventReload();

  // Inject "mouseflow"
  mouseflow.init(() => {
    mouseflow.setVariable("experiment", ABTesting.getExperiment());
  });
}

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.NODE_ENV,
    environment: process.env.NODE_ENV,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    beforeSend(event) {
      mouseflow.tag("app-error");

      return event;
    },
  });
}

if (process.env.REACT_APP_LOGROCKET) {
  LogRocket.init(process.env.REACT_APP_LOGROCKET);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
